import React, { useEffect, useState } from 'react'
import bannerImg from "../../../assets/images/idfcReg/banner-img.png"
import { fetchWithWait, getUserMachinePublicIp, isValidMobileNo, isValidOtp } from '../../../helper/method'
import produce from 'immer'
import RegMobileNo from '../../molecules/regMobileNo'
import { useDispatch, useSelector } from 'react-redux'
import { resendOtp, setUser } from '../../../redux/actions/user'
import { clearLoading, setLoading } from '../../../redux/actions/loader'
import { setResponseErrorSnack } from '../../../redux/actions/responseError'
import { apiErrorResponse, userType } from '../../../helper/constant'
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import { capitalCase } from 'change-case';
import history from "../../../lib/history";
import RegistrationApi from '../../../services/registrationApi'
import firebase from "../../molecules/firebase";
import $ from 'jquery';
import RegInput from '../../molecules/regInput'
import { gotoVerificationPage } from '../../../redux/actions/proof'
import classNames from 'classnames'






const RegFormIdfc = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const auRm = useSelector((state) => state.auRmDetails.auRm);
    const analytics = useSelector((state) => state.analytics);


    const handleSetUser = (data) => dispatch(setUser(data));
    const handleResendOtp = (data) => fetchWithWait({ dispatch, action: resendOtp(data) });
    const resumeForm = (data) => fetchWithWait({ dispatch, action: gotoVerificationPage(data) })
    const handleSetLoading = (data) => dispatch(setLoading(data));
    const handleClearLoading = () => dispatch(clearLoading());
    const handleSetResponseErrorSnack = (payload) => dispatch(setResponseErrorSnack(payload));

    const [fullName,setFullName] = useState("")
    const [mobileNo, setMobileNo] = useState("");
    const [error, setError] = useState({});
    const [otp, setOtp] = useState("")
    const [latitude, setLatitude] = useState("")
    const [longitude, setLongitude] = useState("")
    const [locationStatus, setLocationStatus] = useState("")
    const [otpTimer, setOtpTimer] = useState(60)
    const [showTimer, setShowTimer] = useState(false)
    const [disableResendButton, setDisableResendButton] = useState(false);
    const [showMobileOtpPopup, setShowMobileOtpPopup] = useState(false);
    const [showCheckBoxes, setShowCheckboxes] = useState(false);
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [schemPlanId,setSchemPlanId] = useState("");
    const [isDIY,setIsDIY] = useState(false);
    const [disableMobileForDiy,setDisableMobileForDiy] = useState(true);
    const [partnerCode,setPartnerCode] = useState("")

    let api = new RegistrationApi();
    let TRACK_URL = process.env.REACT_APP_TRACK_URL;
    let TRADE_URL = process.env.REACT_APP_FINISH_URL;
    const otpLength = 4;

    useEffect(() => {
        const fetchLatLong = async () => {
            let latlongRes = await getUserMachinePublicIp();
            console.log("IP public=", latlongRes);
            if (typeof latlongRes === "object") {
                setLatitude(latlongRes.latitude);
                setLongitude(latlongRes.longitude)
            } else {
                setLocationStatus(latlongRes)
            }
        }
        fetchLatLong()
    }, [])


    useEffect(()=>{
        if(user.diyId){
            checkDiyBa();
        }
    },[user.diyId])


    // Diy logic
    const checkDiyBa = () => {

        if (!user.diyId) {
            return;
        }

        let data = {
            _guid: user.diyId
        }

        // this.props.setLoading({ message: "We are fetching your details..." })
        handleSetLoading({ message: "" });

        api.getBaDiyDetails(data).then(response => {
            console.log('diy ba response', response);
            handleClearLoading()

            if (response.data) { //set user field for diy

                handleSetUser({
                    applicationType: response.data[0].APPLICATIONTYPE,
                    strPSource: response.data[0].PSOURCE,
                    appLoginId:response.data[0].PARTNERCODE
                })

                setMobileNo(response.data[0].MOBILE);
                setFullName(response.data[0].NAME)
                setSchemPlanId(response.data[0].SCHEMEPLANID);
                setPartnerCode(response.data[0].PARTNERCODE)
                setIsDIY(true);

                if (response.data[0].MOBILE === null || response.data[0].MOBILE === '') {
                    setDisableMobileForDiy(false)
                }

            } else {
                setError(prevState => produce(prevState, draft => {
                    draft.apiResponse = response.data.Message;
                    // draft.isShowErrorPopup = true;
                }))
            }
        }).catch(error => {
            handleClearLoading();
            setError(prevState => produce(prevState, draft => {
                draft.apiResponse = apiErrorResponse;
                // draft.isShowErrorPopup = true;
            }))
        })

    }

    const handleInputChange = ({ name, value }) => {
        console.log('handleInputChange name,value', name, value)
        if (name === "mobileNo" && value.length != 0) {
            let validMob = isValidMobileNo(value);

            if (!validMob) {
                return false;
            }
        } else if (name === 'otp') {
            if (!isValidOtp(value)) {
                return;
            }
        }
        clearError(name);
        if (!(name === 'otp' && value.length > otpLength)) {
            if (name == "otp") {
                setOtp(value)
            }
            // return false;
        }
        if (name === "mobileNo") {
            setMobileNo(value)

        }

    }

    //#region any input field blur is handled here.
    const handleInputBlur = ({ name, value, isRequired }) => {
        console.log('Input blur', name, value, isRequired);
        validateField({ name, value, isRequired });
    }

    //#region validation of field 
    const validateField = ({ name, value, isRequired, callback = () => { } }) => {
        console.log('validate', name, value, isRequired)
        if (isRequired && !value) {// value is reqd but left blank
            callback();
            setError(prevState => produce(prevState, draft => {
                if (name === "mobileNo") {
                    draft[name] = 'Please enter your Mobile Number';
                } else if (name === "otp") {
                    draft[name] = 'Please enter OTP';
                }

            }), () => {
                console.log('error set')
            })
        } else if (name === "mobileNo") {
            validateMobileNumber({ name, value, callback })
        } else if (name === "otp") {
            validateOtp({ name, value, callback })
        }
    }
    //#endregion

    const validateMobileNumber = ({ name, value, callback }) => {
        let vailid = isValidMobileNo(value);
        console.log('vailid', vailid)
        if (!vailid || value.length < 10) {
            callback();
            setError(prevState => produce(prevState, draft => {
                draft[name] = 'Please enter valid Mobile Number';
            }))
        }
    }

    const validateOtp = ({ name, value, callback }) => {
        if (value.length < otpLength) {
            callback();
            setError(prevState => produce(prevState, draft => {
                draft[name] = `OTP must be of ${otpLength} digits`;
            }))
        }
    }


    const clearError = (name) => {
        setError(prevState => produce(prevState, draft => {
            delete draft[name]
        }), () => {
            console.log('error cleared');
        })
    }

    const validateForm = () => {
        let decision = true;

        const makeDecision = () => {
            decision = false;
        }

        let fieldsToValidate = [
            { name: 'mobileNo', value: mobileNo, isRequired: true },
        ]
        fieldsToValidate = fieldsToValidate.filter(field => field);
        fieldsToValidate.forEach(field => validateField({ ...field, callback: makeDecision }))
        console.log('fieldsToValidate', fieldsToValidate);
        return decision;
    }


    const sendOtp = (data) => {
        handleSetLoading();
        handleResendOtp(data).then(response => {
            console.log(response, "response")
            handleClearLoading();
            if (response.Status === "1") {
                handleSetUser({ uniqueId: response._Uniqueid })
                // otp is successfully resend.
                setShowOtpScreen(true);
                otpTimerFunc();

            } else if (response.Status === "0") {

                setError(prevState => produce(prevState, draft => {
                    draft.apiResponse = response.Message;
                    // draft.isShowErrorPopup = true;
                }))
            }
        }).catch(error => {
            handleClearLoading();
            console.log(error, "Error **")
            setError(prevState => produce(prevState, draft => {
                draft.apiResponse = error.Message;
                // draft.isShowErrorPopup = true;
            }))
        })
    }

    const handleResendOtpFunc = () => {

        // if (this.validateForm()) {
        let data = {
            _mobile: mobileNo,
            ISRESENDOTP: "1"
        }
        handleSetLoading()
        handleResendOtp(data).then(response => {
            console.log(response, "response resend otp")
            handleClearLoading()
            if (response.Status === "1") {

                // otp is successfully resend.

                setOtp("")
                setError(prevState => produce(prevState, draft => {
                    draft.otp = response.Message;
                    draft.apiResponse = "";
                }))

                setDisableResendButton(true)
                setOtpTimer(60);
                setShowTimer(true);
                otpTimerFunc()

            } else if (response.Status === "0") {
            }
        }).catch(error => {
            // this.props.clearLoading();
            handleClearLoading()
            setError(prevState => produce(prevState, draft => {
                // draft.otp = response.data.Message;
                draft.apiResponse = error.message;
            }))
        })
        // }
    }

    const getOpenAccountReqData = () => {
        let data;
        let applicationType = user.applicationType;
        //  if (applicationType.toLowerCase() === userType.direct.toLowerCase()) {// direct user
            data = {
                _name: fullName || "",
                // _name: "",
                _mobile: mobileNo,
                _city: "",
                // _state: this.state.values.fetchedState,
                // IsSouthCitySelected: this.state.values.isSouthIndian ? "1" : "0",
                _strSource: 'Online',
                _interestedin: 'All',
                ApplicationType: 'CRM',
                // AppLoginId: user.appLoginId || "",
                AppLoginId: partnerCode || user.appLoginId,
                _applicationFrom: 'Web',
                isOcrUser: '1',
                // _strPSource: this.props.user.source ? this.props.user.source : '',
                // _strPSource: isMobile ? "Mobilesite" : "Website",
                _strPSource: user.source ? user.source : isMobile ? "Mobilesite" : "Website",
                _strPSourceDetails: user.sourceDetail ? user.sourceDetail : '',
                IsTrueCaller:  "0",
                // IsNewReferral: (this.state.values.IsValid === true && this.state.values.refereeNamee !== "") ? "1" : "0",
                // Referee_Code: this.state.values.refereeCode,
                // Referee_Name: this.state.values.refereeName,
                // Referral_via: this.state.values.referedVia,
                // Referee_clientCode: this.state.values.refereeClientCode,
                Token_send: "1",
                Latitude: latitude,
                Longitude: longitude,
                LocationErrorMSG: locationStatus
            }            
        return data;
    }

    const openAccount = () => {
        // this.props.handleCurrentOTPForm(this.state.values.fullName, this.state.values.mobileNo, this.state.values.isSouthIndian, this.state.values.showPartner, this.state.values.partnerCode, this.state.selectedLanguage, this.state.values.referralCode);
        // history.push('/mobileOTP');
        // return;

        let data = getOpenAccountReqData();
        let applicationType = user.applicationType;
        let TRADE_URL = process.env.REACT_APP_FINISH_URL;
        handleSetLoading()
        console.log('openAccount request=', data);
        api.openAccount(data).then(response => {
            console.log('openAccount response', response);
            handleClearLoading()
            if (response.data.code == "200") {
                if (response.data.Status) {
                    // sessionStorage.removeItem('webCam');
                    // sessionStorage.removeItem('webCamChecked');

                    if (response.data.Data.ISSUPERJET !== "1" && response.data.Data.ISJET !== "1") {
                        window.location = response.data.Data._ReturnURL;
                        return;
                    }

                    setError(prevState => produce(prevState, draft => {
                        draft.apiResponse = "";
                    }))
                    if (response.data.Data && response.data.Data.Status === "4") {//new user
                        setShowOtpScreen(true);
                        otpTimerFunc();
                       
                        if (user.applicationType === userType.direct || user.applicationType === 'direct') {
                            // let screenTimer = sessionStorage.getItem('screenTimer');
                            // if (screenTimer <= 0) {
                            window.dataLayer.push({
                                event: 'lead_filled',
                                Parameters: [{
                                    //   'language': this.state.selectedLanguage,
                                    'mobile_number': mobileNo,
                                    //   'referral_code': this.state.values.referralCode,
                                    //   'south_indian_language': this.state.values.isSouthIndian ? "yes" : "no",
                                    'ekycuserid': response.data.Data.UserId,
                                    'lsqid': response.data.Data.LSQLeadId,
                                    'ProspectOpportunityId': response.data.Data.OpportunityId
                                }]
                            });
                            console.log("pushed event on reg page => ", window.dataLayer);


                            window.clevertap.event.push(
                                "lead_filled",
                                {
                                    //   "language": this.state.selectedLanguage,
                                    "mobile_number": mobileNo,
                                    //   "referral_code": this.state.values.referralCode,
                                    //   "south_indian_language": this.state.values.isSouthIndian ? "yes" : "no",
                                    "ekycuserid": response.data.Data.UserId,
                                    "lsqid": response.data.Data.LSQLeadId,
                                    'ProspectOpportunityId': response.data.Data.OpportunityId
                                }
                            );
                            console.log("pushed clevertap event => ", window.clevertap);

                            // window.clevertap.event.push(
                            //     "lead_verified",
                            //     {
                            //         "full_Name": this.state.values.fullName,
                            //         "language": this.state.selectedLanguage,
                            //         "mobile_number": this.state.values.mobileNo,
                            //         "referral_code": this.state.values.referralCode,
                            //         "south_indian_language": this.state.values.isSouthIndian ? "yes" : "no",
                            //         "ekycuserid": response.data.Data.UserId,
                            //         "lsqid": response.data.Data.LSQLeadId,
                            //         'ProspectOpportunityId': response.data.Data.OpportunityId
                            //     }
                            // );
                            // console.log("pushed clevertap event => ", window.clevertap);

                            var presentDate = new Date().toLocaleString().slice(0, 10);

                            window.clevertap.onUserLogin.push({
                                "Site": {
                                    //   "Name": this.state.values.fullName,
                                    "Phone": "+91" + mobileNo, // Phone (with the country code)
                                    "Identity": "",
                                    "Gender": "", // Can be either M or F
                                    DOB: new Date(), // Date of Birth. Date object
                                    // optional fields. controls whether the user will be sent email, push etc.
                                    "MSG-email": false, // Disable email notifications
                                    "MSG-push": true, // Enable push notifications
                                    "MSG-sms": true, // Enable sms notifications
                                    "MSG-whatsapp": true, // Enable WhatsApp notifications
                                    "customer_status": "Lead",
                                    "lead_filled_date": presentDate,
                                    "ekycuserid": user.id,
                                }
                            })
                            // }

                            // window.clevertap.profile.push({
                            //     "Site": {
                            //         "customer_status": "Lead",
                            //         "lead_filled_date": presentDate,
                            //         "ekycuserid": this.props.user.id,
                            //     }
                            // })
                        }

                        handleSetUser({
                            // type: this.state.values.showPartner ? userType.pp : userType.direct,
                            id: response.data.Data.UserId,
                            tokenKey: response.data.Data.TokenKey,
                            uniqueId: response.data.Data._uniqueId,
                            //   fullName: capitalCase(this.state.values.fullName),
                            mobileNumber: mobileNo,
                            isOtpRequired: true,
                            lsqId: response.data.Data.LSQLeadId,
                            opportunityId: response.data.Data.OpportunityId
                        })
                      

                    } else if (response.data.Data && response.data.Data.IsMobileNoAlreadyExists) {//already existed user
                        //   if (this.state.IsTrueCallerUser) {
                        //       // window.location = response.data.Data._ReturnURL;
                        //       // return;
                        //       this.resumeApplication();
                        //   } else {
                        let data = {
                            _mobile: mobileNo
                        }
                        sendOtp(data)
                    } else if (response.data.Data && response.data.Data.IsMobileNoAlreadyExists && this.props.user.strPSource == "LIVEPHOTO") {//already existed user crm/ba

                        let data = {
                            _mobile: mobileNo
                        }
                        sendOtp(data)

                    } else if (response.data.Data && response.data.Data.IsPrivilege) {
                        window.location = TRADE_URL;
                    } else {
                        console.log("response else block",response.data.Data)
                        setError(prevState => produce(prevState, draft => {
                            draft.apiResponse = response.data.Data.Message;
                            // draft.isShowErrorPopup = true;
                        }))
                    }
                } else {
                    if(response.data.Data && response.data.Data.ResumeIDFC =="1"){
                        let data = {
                            _mobile: mobileNo
                        }
                        sendOtp(data)
                    }else{
                        setError(prevState => produce(prevState, draft => {
                            draft.apiResponse = response.data.Message;
                            // draft.isShowErrorPopup = true;
                        }))
                    }
                    
                }
            } else {
                //added by sushil
                const EkycApiFailRef = firebase.database().ref(process.env.REACT_APP_FIREBASE_OBJECT_NAME);
                const EkycApiFailData = {
                    ApplicationType: data.ApplicationType,
                    IsSouthCitySelected: data.IsSouthCitySelected,
                    isOcrUser: data.isOcrUser,
                    _applicationFrom: data._applicationFrom,
                    _city: data._city,
                    _interestedin: data._interestedin,
                    _mobile: data._mobile,
                    _name: data._name,
                    _state: data._state,
                    _strPSource: data._strPSource,
                    _strPSourceDetails: data._strPSourceDetails,
                    _strSource: data._strSource,
                    IsNewReferral: data.IsNewReferral,
                    Referee_Code: data.Referee_Code,
                    Referee_Name: data.Referee_Name,
                    Referral_via: data.Referral_via,
                };
                EkycApiFailRef.push(EkycApiFailData);
            }

        }).catch(error => {
            handleClearLoading();
            setError(prevState => produce(prevState, draft => {
                draft.apiResponse = apiErrorResponse;
                // draft.isShowErrorPopup = true;
            }))
            // alert("called")
            console.log(' openAccount error', error);
        })
    }

    console.log(otp, otpTimer, showTimer, "*********")

    const handleOpenAccount = () => {
        let valid = validateForm();
        console.log('handleOpenAccount valid', valid);
        if (valid) {
            console.log('send req')
            openAccount();
        }
    }

    const handleValidateOtp = () => {
        let valid = false;
        if (otp && otp.length == otpLength) {
            valid = true
        } else {
            valid = false
            setError(prevState => produce(prevState, draft => {
                draft["otp"] = 'Please enter OTP';
            }))
        }
        console.log('handleOpenAccount valid', valid);
        if (valid) {
            console.log('send req for otp verify')
            verifyOtpApi();
        }
    }

    const getPage = (pageName, ApplicationType) => {
        switch (pageName) {
            case 'OTPEMAIL':
                return 'verifyEmail'
            case 'ESIGN':
                return 'esign'
            case 'KRAESIGN':
                return 'esignKra'
            case 'DDPIESIGN':
                return 'esignDdpi'
            case 'PERSONALDETAIL':
                return 'personalAndNominee'
            case 'FUNDTRANSFER':
                if (ApplicationType == userType.crm || ApplicationType == userType.pp) {
                    return 'scheme'
                } else {
                    return 'fundTransferScheme'
                }
            case 'PANBANK':
                return 'panBankUpload'
            case 'PAN':
                return 'pan'
            case 'BANK':
                return 'bank'
            case 'PROOFUPLOAD':
                return 'adhaarPhotoIncomeProof'
            case 'CONGRATULATION':
                return 'congratulation'
            case 'VERIFICATION':
                return 'verification'
            case 'TRACKER':
                return 'tracker'
            case 'TRADE':
                return 'trade'
            case 'CMRCOPY':
                return 'cmr'
            default:
                break;
        }
    }

    const callResumeForm = (applicationType) => {
        let type;
        if (applicationType.toLowerCase() === userType.direct.toLowerCase()) {
            type = 'dad';
        } else if (applicationType.toLowerCase() === userType.crm.toLowerCase()) {
            type = 'branch';
        } else if (applicationType.toLowerCase() === userType.pp.toLowerCase()) {
            type = 'ba';
        }

        let currentUrl = window.location.origin + process.env.REACT_APP_PUBLIC_URL + '/' + type + '/verifyEmail';
        let successUrl = window.location.origin + process.env.REACT_APP_PUBLIC_URL + '/' + type + '/esign';

        let data = {
            ReturnURLSUCCESS: successUrl,
            ReturnURLFAILURE: currentUrl,
            Type: 'CLIENTLOGIN'
        }
        resumeForm(data).then(res => {
            window.location.href = res[0].RESUMEFORM_URL;
        })
    }


    const otpTimerFunc = () => {
        // debugger
        let myInterval = setInterval(() => {
            setOtpTimer(prevOtpTimer => {
                if (prevOtpTimer > 0) {
                    return prevOtpTimer - 1;
                } else {
                    clearInterval(myInterval);
                    setShowTimer(false);
                    return 0; // To prevent going negative
                }
            });
            console.log("Timer1=>", otpTimer);
        }, 1000);

        setTimeout(() => {
            setDisableResendButton(false);
        }, 60000);
    }

    const redirect = (applicationType, page, isDiy) => {
        if (applicationType.toLowerCase() === userType.direct.toLowerCase()) {
            history.push(`/dad/${page}`);
        } else if (applicationType.toLowerCase() === userType.crm.toLowerCase()) {
            history.push(`/branch/${page}`);
        } else if (applicationType.toLowerCase() === userType.pp.toLowerCase()) {
            history.push(`/ba/${page}`);
        }
    }


    const verifyOtpApi = () => {
        let applicationType = user.applicationType;
        let uniqueIdRequest = user.uniqueId;

        let data = {
            UserId: mobileNo,
            _password: otp,
            _uniqueId: user.uniqueId,
            BranchEmpCode: user.branchEmpCode || user.branchEmpCodeFromRedirect,
            AppLoginId: user.appLoginId || user.appLoginIdFromRedirect,
            IsDIY: user.isDiy,
            IsBRBALogin: user.isBRBALogin
        }
        handleSetLoading();
        api.resumeApplication(data).then(response => {
            handleClearLoading();
            if (response.data.Status) {

                if (response.data.Data.ISSUPERJET !== "1") {
                    window.location = response.data.Data._ReturnURL;
                    return;
                }

                setError(prevState => produce(prevState, draft => {
                    draft.apiResponse = "";
                }))

                if (response.data.Data && response.data.Data.Status === "1") {//new user

                    if (uniqueIdRequest !== response.data.Data._uniqueId) {

                        setError(prevState => produce(prevState, draft => {
                            draft.otp = "OTP entered is incorrect";
                        }))
                        return;
                    }

                    handleSetUser({
                        // type: this.state.values.showPartner ? userType.pp : userType.direct,
                        id: response.data.Data.UserId,
                        tokenKey: response.data.Data.TokenKey,
                        uniqueId: response.data.Data._uniqueId,
                        // fullName: capitalCase(this.state.values.fullName),
                        mobileNumber: mobileNo,
                        isOtpRequired: true,
                        lsqId: response.data.Data.LSQLeadId,
                        opportunityId: response.data.Data.OpportunityId
                    })

                    let page = getPage(response.data.Data.PageName, response.data.Data.ApplicationType); // get page logic
                    console.log('page', page)
                    if (page === 'verification') {
                        callResumeForm(response.data.Data.ApplicationType);
                    } else if (page === 'tracker') {
                        window.location = TRACK_URL;
                        return
                    } else if (page === 'trade') {
                        window.location = TRADE_URL;
                        return
                    }

                    if (user.applicationType === userType.direct || user.applicationType === 'direct') {

                        if ((sessionStorage.client_name !== "" && sessionStorage.client_name !== undefined) || (sessionStorage.client_mobile !== "" && sessionStorage.client_mobile !== undefined)) {
                            var presentDate = new Date().toLocaleString().slice(0, 10);
                            window.clevertap.onUserLogin.push({
                                "Site": {
                                    "Name": "",
                                    "Phone": "+91" + mobileNo, // Phone (with the country code)
                                    "Identity": "",
                                    "Gender": "", // Can be either M or F
                                    DOB: new Date(), // Date of Birth. Date object
                                    // optional fields. controls whether the user will be sent email, push etc.
                                    "MSG-email": false, // Disable email notifications
                                    "MSG-push": true, // Enable push notifications
                                    "MSG-sms": true, // Enable sms notifications
                                    "MSG-whatsapp": true, // Enable WhatsApp notifications
                                    "customer_status": "Lead",
                                    "lead_filled_date": presentDate,
                                    "ekycuserid": user.id,
                                }
                            })
                        }

                        window.dataLayer.push({
                            event: 'lead_verified',
                            Parameters: [{
                                'mobile_number': mobileNo,
                                'truecaller_verified': "no",
                                'ekycuserid': response.data.Data.UserId,
                                'lsqid': response.data.Data.LSQLeadId,
                                'ProspectOpportunityId': response.data.Data.OpportunityId
                            }]
                        });
                        console.log("pushed event on reg page => ", window.dataLayer);


                        window.clevertap.event.push(
                            "lead_verified",
                            {
                                "mobile_number": mobileNo,
                                "truecaller_verified": "no",
                                "ekycuserid": response.data.Data.UserId,
                                "lsqid": response.data.Data.LSQLeadId,
                                'ProspectOpportunityId': response.data.Data.OpportunityId
                            }
                        )
                        console.log("pushed clevertap event => ", window.clevertap);
                    }

                    redirect(response.data.Data.ApplicationType, page);//redirect logic on positive response

                } else if (response.data.Data && response.data.Data.IsMobileNoAlreadyExists && (applicationType.toLowerCase() === userType.direct.toLowerCase())) {//already existed user

                    let data = {
                        _mobile: mobileNo
                    }
                    sendOtp(data)

                } else if (response.data.Data && response.data.Data.IsMobileNoAlreadyExists && this.props.user.strPSource == "LIVEPHOTO") {//already existed user crm/ba

                    let data = {
                        _mobile: mobileNo
                    }
                    sendOtp(data)

                } else if (response.data.Data && response.data.Data.IsPrivilege) {
                    window.location = TRADE_URL;
                } else {
                    // this.setState(prevState => produce(prevState, draft => {
                    //     draft.error.otp = response.data.Data.Message;
                    //     draft.isShowErrorPopup = true;
                    // }))
                    setError(prevState => produce(prevState, draft => {
                        draft.otp = response.data.Data.Message;
                    }))
                }
            } else {
                // this.setState(prevState => produce(prevState, draft => {
                //     draft.error.otp = response.data.Message;
                //     draft.isShowErrorPopup = true;
                // }))
                setError(prevState => produce(prevState, draft => {
                    draft.otp = response.data.Message;
                }))
            }

        }).catch(error => {
            console.log('resumeApplication error', error);
            handleClearLoading()
            // this.props.clearLoading();
            // this.setState(prevState => produce(prevState, draft => {
            //     draft.error.apiResponse = apiErrorResponse;
            // }))
            setError(prevState => produce(prevState, draft => {
                draft.apiResponse = apiErrorResponse;
            }))
        })
    }



    return (
        <div className="container_new">
            <div className="dflex spacebetween">
                <div className="d55 intro-info mt-5">
                    <h2 className="title text-brown f58 r16 font-bold">Savings, Demat & Tradings</h2>
                    <div className="mtop8"></div>
                    <p className="f30 r12 semibold">3 Financial needs, 1 account</p>
                    <div className="mtop8"></div>
                    <p className="f24 r12">Discover the ease of managing your savings, <br className="desk" /> Trading and Demat with our <span
                        className="font-bold f24 r12"> 3-in-1 account</span>
                    </p>
                    <div className="mtop24"></div>
                    {/* Reg input au */}
                    {/* ui work starts here  */}
                    <div className="phone-no d35 desk ">
                        <div className="dflex alignbaseline reg-input-container">
                            <span className="text-brown">+91</span>
                            <RegMobileNo
                                name={"mobileNo"}
                                value={mobileNo}
                                // error={error.mobileNo}
                                customhook={true}
                                onChange={handleInputChange}
                                onBlur={handleInputBlur}
                                customDobClass={"form-control"}
                                placeholder={"Enter phone number"}
                                disabled={showOtpScreen || (isDIY && disableMobileForDiy)}
                            />
                        </div>
                    </div>
                    {!isMobile && error.apiResponse !== "" &&
                        <>
                        <div className='custom-err-cont'>
                            <div class="mtop10"></div>
                            <div className={'reg-error'}>{error.apiResponse}</div>
                        </div>
                        </>
                    }  
                    <div className={classNames('reg-error dad-error disappear text-left desk', { 'appear': error.mobileNo })}>{error.mobileNo}</div>
                    <div className="mtop16 desk"></div>
                    {!showOtpScreen && <div className="form-group d40 desk">
                        <button name="btnSendRep" className="btn btn-brown btn-block pointer" onClick={handleOpenAccount}>
                            Open your account
                        </button>
                    </div>}

                    {showOtpScreen && <div className="">
                        <div className="phone-no d35 desk otp-container">
                            <div className="dflex align-center">

                                <RegInput
                                    name={"otp"}
                                    value={otp}
                                    error={error.otp}
                                    onChange={handleInputChange}
                                    onBlur={handleInputBlur}
                                    placeholder="Enter OTP"
                                    className={"form-control"}
                                    maxLength={4}
                                    // Label={"Enter Mobile OTP"}
                                    // otpTimer={otpTimer}
                                    // showOtp={mobileNo}
                                    type={"tel"}
                                />

                            </div>

                        </div>
                        <div className="mtop16 desk"></div>
                        <div className="mtop30 desk"></div>
                        <div className="form-group d40 desk">
                            <button name="btnSendRep" className={`btn btn-brown btn-block pointer ${error.otp && "mtop16"}`} onClick={handleValidateOtp}>
                                Valided OTP
                            </button>
                        </div>
                        {otpTimer > 0 && <div className='otptext text-brown mtop10 desk'>Resend OTP in {otpTimer} seconds</div>}

                    </div>}

                    {showOtpScreen && otpTimer == 0 && <div className="">
                        <div className="mtop16 desk"></div>
                        <div className="form-group d40 desk">
                            <button name="btnSendRep" className="btn btn-brown btn-block pointer" onClick={handleResendOtpFunc}>
                                Re-send OTP
                            </button>
                        </div>
                    </div>}
                </div>
                <div className="d45">
                    <div className="">
                        <img src={bannerImg} className="m-auto banner-img" />
                    </div>
                </div>
            </div>
            <div className="mtop24 mob"></div>
            <div className="phone-no mob">
                <div className="dflex aligncenter">
                    <span className="text-brown">+91</span>
                    <RegMobileNo
                        name={"mobileNo"}
                        value={mobileNo}
                        // error={error.mobileNo}
                        customhook={true}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        customDobClass={"form-control"}
                        placeholder={"Enter phone number"}
                        disabled={showOtpScreen || (isDIY && disableMobileForDiy)}
                    />
                </div>
            </div>
            <div className={classNames('reg-error dad-error disappear text-left mob', { 'appear': error.mobileNo })}>{error.mobileNo}</div>
            {isMobile && error.apiResponse !== "" &&
                        <>
                        <div className='custom-err-cont'>
                            <div class="mtop10"></div>
                            <div className={'reg-error'}>{error.apiResponse}</div>
                        </div>
                        </>
                    }
            <div className="mtop16 mob"></div>

            {!showOtpScreen && <div className="form-group mob">
                <button name="btnSendRep" className="btn btn-brown btn-block pointer" onClick={handleOpenAccount}>
                    Open your account
                </button>

            </div>}

            {showOtpScreen && <div className="">
                <div className="phone-no mob">
                    <div className="dflex align-center">

                        <RegInput
                            name={"otp"}
                            value={otp}
                            // error={error.otp}
                            onChange={handleInputChange}
                            onBlur={handleInputBlur}
                            placeholder="Enter OTP"
                            className={"form-control"}
                            maxLength={4}
                            // Label={"Enter Mobile OTP"}
                            // otpTimer={otpTimer}
                            // showOtp={mobileNo}
                            type={"tel"}
                        />

                    </div>
                </div>
                <div className="mtop16"></div>
                <div className={classNames('reg-error dad-error disappear f12 mob', { 'appear': error.otp })}>{error.otp}</div>
                <div className="form-group mob">
                    <button name="btnSendRep" className={`btn btn-brown btn-block pointer ${error.otp && "mtop16"}`} onClick={handleValidateOtp}>
                        Valided OTP
                    </button>
                </div>
                {otpTimer > 0 && <div className='otptext text-brown mtop10 mob'>Resend OTP in {otpTimer} seconds</div>}

            </div>}

            {showOtpScreen && otpTimer == 0 && <div className="">
                <div className="mtop16"></div>
                <div className="form-group mob">
                    <button name="btnSendRep" className="btn btn-brown btn-block pointer" onClick={handleResendOtpFunc}>
                        Re-send OTP
                    </button>
                </div>
            </div>}

        </div>
    )
}

export default RegFormIdfc
